<template>
  <create-dialog
    width="70%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <fg-input
            :label="`${$t('common_words.code')}:`"
            :disabled="true"
            ref="code"
            type="number"
            :value="getNextCode"
            v-model="model.code"
          >
          </fg-input>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <div class="form-group has-label">
            <label>*{{ $t('common_words.farms') }}: </label>
            <br />
            <el-select
              @change="getSupplyingByFarm()"
              clearable
              :disabled="disableFarms"
              filterable
              class="select-primary custom-width-select shadow-sm required-farm"
              size="large"
              v-model="model.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
          <div class="form-group has-label">
            <label>*{{ $t('inventory.supplying') }}: </label>
            <br />
            <el-select
              @change="getArticlesBySupplying()"
              clearable
              filterable
              class="select-primary custom-width-select shadow-sm required-supplying"
              size="large"
              v-model="model.supplying_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in supplyingsByFarm"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
          <div class="form-group has-label">
            <label>{{ $t('shopping.request_status') }}:</label>
            <br />
            <el-select
              :disabled="disable_create ? true : false"
              clearable
              filterable
              :class="`select-primary custom-width-select mb-3 shadow-sm required-request_status`"
              v-model="model.status_request"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="option in getStatusRequest"
                :key="option.id + option.value"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group has-label">
            <div class="form-group has-label">
              <label>{{ $t('common_words.description') }}: *</label>
              <br />
              <el-input
                maxlength="255"
                show-word-limit
                class="shadow-sm"
                type="textarea"
                :placeholder="`${$t('labor.enter_abscence_type')}...`"
                v-model="model.description"
              ></el-input>
              <br />
            </div>
          </div>
        </div>
        <div :class="`col-12`">
          <div class="form-group has-label">
            <label>{{ $t('inventory.supplying_belongs_to_farm') }} </label>
            <el-switch
              @change="disableFarm()"
              v-model="supplyingBelongsToFarm"
              :active-text="`${$t('common_words.yes')}`"
              :inactive-text="`${$t('common_words.no')}`"
              style="margin-left: 1rem"
              active-color="#6BA652"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        :title="$t('shopping.material_request')"
      >
        <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
          <div class="table-responsive">
            <table
              class="table table-striped table-bordered not-last-td table-data"
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th scope="col" class="text-center p-3 custom-header-label">
                    <strong>* {{ $t('inventory.article') }}</strong>
                  </th>
                  <th scope="col" class="text-center p-3 custom-header-label">
                    <strong>* {{ $t('inventory.unit_of_measure') }}</strong>
                  </th>
                  <th scope="col" class="text-center p-3 custom-header-label">
                    <strong>* {{ $t('common_words.quantity') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '100px', marginTop: '6px' }"
                  >
                    <strong>{{ $t('common_words.options') }}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="index in model.numberArticles" :key="index">
                  <td class="text-center">
                    <el-select
                      @change="
                        getUnitNameByArticle(index - 1),
                          uniqueItemValidator(index - 1)
                      "
                      clearable
                      filterable
                      style="min-width: 110px"
                      :class="`select-primary custom-width-select shadow-sm m-3 required-article${
                        index - 1
                      }`"
                      size="large"
                      v-model="model.articles_id[index - 1]"
                      :placeholder="`${$t('common_words.select')}...`"
                    >
                      <el-option
                        v-for="(option, index) in articlesBySupplying"
                        class="select-primary"
                        :value="option.id"
                        :label="option.name"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <fg-input
                      type="text"
                      class="m-3 text-center"
                      :disabled="true"
                      v-model="model.unit_name_article[index - 1]"
                    >
                    </fg-input>
                  </td>
                  <td class="text-center">
                    <fg-input
                      type="number"
                      step="0.1"
                      class="m-3 text-center"
                      v-model="model.quantity[index - 1]"
                      :name="`common_words.quantity_${index}`"
                      v-validate="modelValidations.quantity"
                      :error="
                        getFieldErrorByIndex(
                          'common_words.quantity',
                          true,
                          index
                        )
                      "
                    />
                  </td>
                  <td class="text-center" style="min-width: 90px">
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isCreate() || isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="model.numberArticles++"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          model.numberArticles > 1 &&
                          (isCreate() || isUpdate() || isDelete())
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(index - 1)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </card>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { extendValidators } from 'src/util/vValidateCustom.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinAlert,
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinPermissions,
    MixinValidations,
  ],
  computed: {
    getStatusRequest() {
      return [
        {
          id: '1',
          value: 'Aprobado',
          label: i18n.t('shopping.approved'),
        },
        {
          id: '2',
          value: 'Pendiente',
          label: i18n.t('shopping.pending'),
        },
        {
          id: '3',
          value: 'Rechazado',
          label: i18n.t('shopping.rejected'),
        },
      ];
    },
    getNextCode() {
      if (isset(this.requestMaterials)) {
        if (this.isEdit == false) {
          this.model.code = (this.requestMaterials[0].id + 1).toString();
        }
      } else {
        this.model.code = '1';
      }
    },
  },
  data() {
    return {
      disabledField: false,
      farms: [],
      articles: [],
      articlesBySupplying: [],
      supplyings: [],
      supplyingsByFarm: [],
      requestMaterials: [],
      disable_create: true,
      disableFarms: false,
      supplyingBelongsToFarm: true,
      isEdit: false,
      model: {
        code: null,
        user_id: null,
        farm_id: null,
        supplying_id: null,
        approving_user_id: null,
        description: null,
        status_request: 'Pendiente',
        numberArticles: 1,
        articles_id: [],
        unit_name_article: [],
        quantity: [],
      },
      modelValidations: {
        quantity: { required: true, positive_decimal: true },
      },
    };
  },
  methods: {
    disableFarm() {
      if (!this.supplyingBelongsToFarm) {
        this.disableFarms = true;
      } else {
        this.disableFarms = false;
      }
      this.model.farm_id = null;
      this.model.supplying_id = null;
      this.getSupplyingByFarm();
      this.getArticlesBySupplying();
    },
    resetArticle() {
      this.articlesBySupplying = [];
      this.model.articles_id = [];
      this.model.unit_name_article = [];
      this.model.quantity = [];
      this.model.numberArticles = 1;
    },
    getSupplyingByFarm() {
      if (!this.supplyingBelongsToFarm) {
        this.supplyingsByFarm = this.supplyings.filter(
          (supplying) => supplying.farms.length === 0
        );
      } else if (isset(this.model.farm_id)) {
        this.supplyingsByFarm = this.supplyings.filter((supplying) =>
          supplying.farms.some((farm) => farm.id === this.model.farm_id)
        );
      } else {
        this.supplyingsByFarm = [];
        this.model.supplying_id = null;
        this.resetArticle();
      }
    },
    getArticlesBySupplying() {
      if (isset(this.model.supplying_id)) {
        this.resetArticle();
        const supplyingChoose = this.supplyingsByFarm.filter(
          (supplying) => this.model.supplying_id === supplying.id
        );
        this.articlesBySupplying = supplyingChoose
          .map((supplying) => supplying.articles)
          .flat();
      } else {
        this.resetArticle();
      }
    },
    getUnitNameByArticle(index) {
      if (isset(this.model.articles_id[index])) {
        const articleChoose = this.articlesBySupplying.find(
          (article) => article.id === this.model.articles_id[index]
        );
        this.$set(
          this.model.unit_name_article,
          index,
          articleChoose.supplying_unit_name
        );
      } else {
        this.$set(this.model.unit_name_article, index, null);
      }
    },
    getDataRegisterForDelete(index) {
      const article = this.articlesBySupplying.find(
        (article) => article.id === this.model.articles_id[index]
      );
      return `
    ${i18n.t('inventory.article')}: ${article.name}`;
    },
    registerSelectDelete(index) {
      this.model.articles_id.splice(index, 1);
      this.model.unit_name_article.splice(index, 1);
      this.model.quantity.splice(index, 1);
      this.model.numberArticles--;
    },
    handleDelete(index) {
      if (isset(this.model.articles_id[index])) {
        SweetAlert.delete(this.getDataRegisterForDelete(index)).then(
          (result) => {
            if (result.value) {
              this.registerSelectDelete(index);
            }
          }
        );
      } else {
        this.registerSelectDelete(index);
      }
    },
    uniqueItemValidator(index) {
      if (this.model.numberArticles > 1) {
        let itemRepeat = 1;
        for (let index2 = 0; index2 < this.model.articles_id.length; index2++) {
          if (this.model.articles_id[index] == this.model.articles_id[index2]) {
            if (itemRepeat > 1) {
              this.model.articles_id[index] = null;
              this.model.unit_name_article[index] = null;
              SweetAlert.warning(
                i18n.t('shopping.duplicate_item_alert')
              );
              break;
            }
            itemRepeat++;
          }
        }
      }
    },
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (this.supplyingBelongsToFarm) {
          if (!isset(this.model.farm_id))
            return this.validationInputsRequired('farm');
          else if (!isset(this.model.supplying_id))
            return this.validationInputsRequired('supplying');
        }
        if (!this.supplyingBelongsToFarm) {
          if (!isset(this.model.supplying_id))
            return this.validationInputsRequired('supplying');
        }
        for (let i = 0; i < this.model.numberArticles; i++) {
          if (!isset(this.model.articles_id[i]))
            return this.validationInputsRequired(`article${i}`);
        }
        if (isValid) {
          this.$emit('addEdit', this.model);
        }
      });
    },
    getDataForUpdate() {
      const supplyingChoose = this.supplyingsByFarm.filter(
        (supplying) => this.model.supplying_id === supplying.id
      );
      this.articlesBySupplying = supplyingChoose
        .map((supplying) => supplying.articles)
        .flat();
      for (let index = 0; index < this.model.articles_id.length; index++) {
        const articleChoose = this.articlesBySupplying.find(
          (article) => article.id === this.model.articles_id[index]
        );
        this.$set(
          this.model.unit_name_article,
          index,
          articleChoose.supplying_unit_name
        );
      }
    },
  },
  created() {
    extendValidators();
  },
  mounted() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('inventory/supplying'),
        Axios.getMasters('shopping/requestmaterial'),
      ])
        .then(([responseFarm, responseSupplying, responseRequestMaterials]) => {
          this.farms = responseFarm.data.data;
          this.supplyings = responseSupplying.data.data;
          this.requestMaterials = responseRequestMaterials.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    }
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      this.isEdit = true;
      this.disable_create = false;
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const {
        id,
        code,
        user_id,
        farm_id,
        supplying_id,
        articles,
        status_request,
        description,
      } = editForm;
      this.model.numberArticles = articles.length;
      this.model = {
        ...this.model,
        id,
        code,
        user_id,
        farm_id,
        articles_id: articles.map((article) => article.id),
        quantity: articles.map((article) => article.pivot.quantity),
        supplying_id,
        description,
        status_request,
        isEdit: true,
      };
      if (!isset(farm_id)) {
        this.supplyingBelongsToFarm = false;
        this.disableFarms = true;
      }
      this.getSupplyingByFarm();
      this.getDataForUpdate();
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
